import React from 'react'

import styles from './UtilityScreen.module.scss'
import images from 'assets/images'

const infoUtility = [
  {
    title: 'Ticker',
    status: 'VIC',
  },
  {
    title: 'Blockchain',
    status: 'Viction',
  },
  {
    title: 'Token type',
    status: 'Utility, Governance',
  },
  {
    title: 'Total supply',
    status: `
      <img src=${images.utilityCoin} alt='' class='status-image' />
      210,000,000 VIC
    `,
  },
  {
    title: 'Max supply',
    status: `
      <img src=${images.utilityCoin} alt='' class='status-image' />
      210,000,000 VIC
    `,
  },
]

const arrOfViction = [
  {
    icon: 'ic-circle',
    title: 'Staking and earn rewards',
    description:
      'Lock your assets and become Voter, Masternode to earn rewards over time',
    linkItem: [
      {
        name: 'Viction Master',
        link: 'https://www.vicmaster.xyz/',
        isBlank: true,
      },
      {
        name: 'Defusion',
        link: 'https://www.defusion.xyz/',
        isBlank: true,
      },
      {
        name: 'VicPool',
        link: 'https://vicpool.fi/',
        isBlank: true,
      },
    ],
  },
  {
    icon: 'icon-global',
    title: 'Global payment',
    description:
      'With USDT, WUSD and other stablecoins you can transfer asset anytime, anywhere',
  },
  {
    icon: 'icon-money',
    title: 'Transaction Fees',
    description: 'Use VIC to pay transaction fees on Viction Network',
    linkItem: [
      {
        name: 'How to get VIC',
        link: '/get-started',
        isBlank: false,
      },
    ],
  },
  {
    icon: 'ic-move',
    title: 'Governance Voting Process',
    description:
      'Take part in voting and contributing to key decisions within the ecosystem',
    linkItem: [
      {
        name: 'Go to Governance',
        link: 'https://gov.viction.xyz/',
        isBlank: true,
      },
    ],
  },
]

function UtilityScreen() {
  return (
    <div className={styles.utilityScreen}>
      <div className='utility-wrapper'>
        <div className='utility-banner'>
          <div className='utility-banner-container'>
            <div className='utility-banner-content'>
              <div className='banner-left'>
                <h1 className='banner-left--title'>VIC Utility</h1>

                <div className='banner-left--description'>
                  Viction constructs the next billion users' ownership economy
                  by tapping into the micro-moments of how we pay, play, invest,
                  and own.
                </div>
              </div>

              <div className='banner-right'>
                <img
                  src={images.utilityBanner}
                  alt=''
                  className='banner-right--image'
                />
              </div>
            </div>

            <div className='utility-info'>
              <div className='utility-info--title'>VIC Key Metric</div>

              <div className='utility-info-content'>
                {infoUtility.map((item, i) => {
                  return (
                    <div className='info-content-item' key={i}>
                      <div className='info-content-item--title'>
                        {item.title}
                      </div>

                      <div
                        className='info-content-item--status'
                        dangerouslySetInnerHTML={{ __html: item.status }}></div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>

        <div className='utility-of-viction'>
          <div className='utility-of-viction-container'>
            <div className='utility-of-viction-title'>Utility of Viction</div>

            <div className='utility-of-viction-detail'>
              {arrOfViction.map((item, i) => {
                const isFirstItem = i === 0

                return (
                  <div className='detail-item' key={i}>
                    <div className='detail-item__icon'>
                      <span className={`icon-${item.icon} icon-detail`}></span>
                    </div>

                    <div className='detail-item__content'>
                      <div className='content-title'>{item.title}</div>

                      <div className='content-description'>
                        {item.description}
                      </div>
                    </div>

                    <div className='detail-item__info'>
                      {isFirstItem && (
                        <div className='info-title'>Stake on:</div>
                      )}

                      <div className='info-link'>
                        {item.linkItem?.map((linkItem, index) => {
                          return (
                            <div className='link-item text-hover-underline'>
                              <a
                                href={linkItem.link}
                                target={linkItem.isBlank ? '_blank' : '_self'}
                                rel='noopener noreferrer'>
                                {linkItem.name}
                              </a>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UtilityScreen
